import _axios from 'axios'
import runtimeConfig from '@/common/runtime-config'

const axios = _axios.create({
  baseURL: runtimeConfig.apiBaseUrl
})

axios.interceptors.request.use(
  config => {
    config.params = {...config.params};
    refreshAuthorizationHeader();
    return config;
  },
  error => {
    return Promise.reject(error);
  }
)

export function refreshAuthorizationHeader() {
  const token = localStorage.getItem('token');
  if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
}

refreshAuthorizationHeader();

export default axios